var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0.046 0,0.046 0,20.023 94.316,81.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.345 0,94.362 39.71,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.73 0,187.747 39.71,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,20.023 256,0.046 161.684,0.046 161.684,81.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.747 256,161.73 216.29,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.276 161.684,256.046 256,256.046 256,236.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.362 256,68.345 216.29,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.069 0,256.046 94.316,256.046 94.316,174.276  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.069 256,216.105 172.232,161.73 196.98,161.73 256,200.041 256,187.747    216.29,161.73 256,161.73 256,148.256 148.211,148.256 148.211,256.046 161.684,256.046 161.684,174.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.256 0,161.73 39.71,161.73 0,187.747 0,206.648 69.197,161.73 93.945,161.73    0,222.712 0,236.069 94.316,174.276 94.316,256.046 107.789,256.046 107.789,148.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0.046 94.316,0.046 94.316,81.816 0,20.023 0,41.885 80.842,94.362 56.094,94.362    0,57.95 0,68.345 39.71,94.362 0,94.362 0,107.836 107.789,107.836  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.836 256,94.362 216.29,94.362 256,68.345 256,49.203 186.432,94.362    161.684,94.362 256,33.139 256,20.023 161.684,81.816 161.684,0.046 148.211,0.046 148.211,107.836  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.256 256,107.836 148.211,107.836 148.211,0.046 107.789,0.046 107.789,107.836    0,107.836 0,148.256 107.789,148.256 107.789,256.046 148.211,256.046 148.211,148.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.73 0,206.648 0,222.712 93.945,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.73 256,216.105 256,200.041 196.98,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.362 0,41.885 0,57.95 56.094,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.362 256,49.203 256,33.139 161.684,94.362  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M366.172,241.595l3.447,10.335l10.895,0.084c0.844,0.007,1.194,1.084,0.515,1.585l-8.764,6.472   l3.286,10.387c0.255,0.805-0.662,1.47-1.348,0.98l-8.863-6.335l-8.863,6.335c-0.687,0.491-1.603-0.175-1.348-0.98l3.286-10.387   l-8.764-6.472c-0.679-0.501-0.329-1.579,0.515-1.585l10.895-0.084l3.447-10.335C364.772,240.795,365.905,240.795,366.172,241.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M319.847,254.307l7.353,8.04l9.987-4.354c0.774-0.337,1.532,0.504,1.115,1.239l-5.374,9.477   l7.227,8.153c0.56,0.632-0.006,1.612-0.833,1.443l-10.674-2.182l-5.52,9.393c-0.428,0.728-1.535,0.492-1.63-0.346l-1.223-10.826   l-10.639-2.348c-0.824-0.182-0.943-1.308-0.174-1.658l9.918-4.508l-1.055-10.844C318.242,254.145,319.277,253.684,319.847,254.307z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M282.697,284.762l9.987,4.354l7.353-8.04c0.57-0.623,1.604-0.162,1.523,0.678l-1.055,10.844   l9.918,4.508c0.768,0.349,0.65,1.476-0.174,1.658l-10.639,2.348l-1.223,10.826c-0.095,0.839-1.203,1.074-1.63,0.346l-5.52-9.393   l-10.674,2.182c-0.827,0.169-1.393-0.812-0.833-1.443l7.227-8.153L281.582,286C281.165,285.266,281.923,284.425,282.697,284.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M261.146,327.694l10.895-0.084l3.447-10.335c0.267-0.801,1.4-0.801,1.667,0l3.447,10.335   l10.895,0.084c0.844,0.007,1.194,1.084,0.515,1.585l-8.764,6.472l3.286,10.387c0.255,0.805-0.662,1.47-1.348,0.98l-8.863-6.335   l-8.863,6.335c-0.687,0.491-1.603-0.175-1.348-0.98l3.286-10.387l-8.764-6.472C259.952,328.778,260.302,327.7,261.146,327.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.92,375.68l9.918-4.508l-1.055-10.844c-0.082-0.84,0.953-1.301,1.523-0.678l7.353,8.04   l9.987-4.354c0.774-0.337,1.532,0.504,1.115,1.239l-5.374,9.477l7.227,8.153c0.56,0.632-0.006,1.612-0.833,1.443l-10.674-2.182   l-5.52,9.393c-0.428,0.728-1.535,0.492-1.63-0.347l-1.223-10.826l-10.639-2.348C258.27,377.155,258.152,376.029,258.92,375.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M276.405,420.422l7.227-8.153l-5.374-9.477c-0.416-0.734,0.341-1.576,1.115-1.239l9.987,4.354   l7.353-8.04c0.57-0.623,1.604-0.162,1.523,0.678l-1.055,10.844l9.918,4.508c0.768,0.349,0.65,1.476-0.174,1.658l-10.639,2.348   l-1.223,10.826c-0.095,0.839-1.203,1.074-1.63,0.347l-5.52-9.393l-10.674,2.182C276.411,422.035,275.845,421.054,276.405,420.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M310.576,454.185l3.286-10.387l-8.764-6.472c-0.679-0.501-0.329-1.579,0.515-1.585l10.895-0.084   l3.447-10.335c0.267-0.801,1.4-0.801,1.667,0l3.447,10.335l10.895,0.084c0.844,0.007,1.194,1.084,0.515,1.585l-8.764,6.472   L331,454.185c0.255,0.805-0.662,1.47-1.348,0.98l-8.863-6.335l-8.863,6.335C311.238,455.656,310.321,454.99,310.576,454.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M355.525,471.13l-1.223-10.826l-10.639-2.348c-0.824-0.182-0.943-1.308-0.174-1.658l9.918-4.508   l-1.055-10.844c-0.082-0.84,0.953-1.301,1.523-0.678l7.353,8.04l9.987-4.354c0.774-0.337,1.532,0.504,1.115,1.239l-5.374,9.477   l7.227,8.153c0.56,0.632-0.006,1.612-0.833,1.443l-10.674-2.182l-5.52,9.393C356.728,472.204,355.62,471.969,355.525,471.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M403.481,468.328l-5.52-9.393l-10.674,2.182c-0.827,0.169-1.393-0.812-0.833-1.443l7.227-8.153   l-5.374-9.477c-0.416-0.734,0.341-1.576,1.115-1.239l9.987,4.354l7.353-8.04c0.57-0.623,1.604-0.162,1.523,0.678l-1.055,10.844   l9.918,4.508c0.768,0.349,0.65,1.476-0.174,1.658l-10.639,2.348l-1.223,10.826C405.017,468.82,403.909,469.056,403.481,468.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M446.151,446.262l-8.863-6.335l-8.863,6.335c-0.687,0.491-1.603-0.175-1.348-0.98l3.286-10.387   l-8.764-6.472c-0.679-0.501-0.329-1.579,0.515-1.585l10.895-0.084l3.447-10.335c0.267-0.801,1.4-0.801,1.667,0l3.447,10.335   l10.895,0.084c0.844,0.007,1.194,1.084,0.515,1.585l-8.764,6.472l3.286,10.387C447.754,446.088,446.838,446.753,446.151,446.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M476.157,408.749l-10.674-2.182l-5.52,9.393c-0.428,0.728-1.535,0.492-1.63-0.346l-1.223-10.826   l-10.639-2.348c-0.824-0.182-0.943-1.308-0.174-1.658l9.918-4.508l-1.055-10.844c-0.082-0.84,0.953-1.301,1.523-0.678l7.353,8.04   l9.987-4.354c0.774-0.337,1.532,0.504,1.115,1.239l-5.374,9.477l7.227,8.153C477.55,407.938,476.984,408.918,476.157,408.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M488.311,362.275l-10.639,2.348l-1.223,10.826c-0.095,0.839-1.203,1.074-1.63,0.347l-5.52-9.393   l-10.674,2.182c-0.827,0.169-1.393-0.812-0.833-1.443l7.227-8.153l-5.374-9.477c-0.416-0.734,0.341-1.576,1.115-1.239l9.987,4.354   l7.353-8.04c0.57-0.623,1.604-0.162,1.523,0.678l-1.055,10.844l9.918,4.508C489.253,360.967,489.135,362.093,488.311,362.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M480.511,314.875l-8.764,6.472l3.286,10.387c0.255,0.805-0.662,1.47-1.348,0.98l-8.863-6.335   l-8.863,6.335c-0.687,0.491-1.603-0.175-1.348-0.98l3.286-10.387l-8.764-6.472c-0.679-0.501-0.329-1.579,0.515-1.585l10.895-0.084   l3.447-10.335c0.267-0.801,1.4-0.801,1.667,0l3.447,10.335l10.895,0.084C480.84,313.296,481.19,314.373,480.511,314.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M454.106,274.745l-5.374,9.477l7.227,8.153c0.56,0.632-0.006,1.612-0.833,1.443l-10.674-2.182   l-5.52,9.393c-0.428,0.728-1.535,0.492-1.63-0.347l-1.223-10.826l-10.639-2.348c-0.824-0.182-0.943-1.308-0.174-1.658l9.918-4.508   l-1.055-10.844c-0.082-0.84,0.953-1.301,1.523-0.678l7.353,8.04l9.987-4.354C453.765,273.169,454.523,274.011,454.106,274.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M413.662,248.825l-1.055,10.844l9.918,4.508c0.768,0.349,0.65,1.476-0.174,1.658l-10.639,2.348   l-1.223,10.826c-0.095,0.839-1.203,1.074-1.63,0.347l-5.52-9.393l-10.674,2.182c-0.827,0.169-1.393-0.812-0.833-1.443l7.227-8.153   l-5.374-9.477c-0.416-0.734,0.341-1.576,1.115-1.239l9.987,4.354l7.353-8.04C412.709,247.524,413.744,247.985,413.662,248.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M366.172,241.595l3.447,10.335l10.895,0.084c0.844,0.007,1.194,1.084,0.515,1.585l-8.764,6.472   l3.286,10.387c0.255,0.805-0.662,1.47-1.348,0.98l-8.863-6.335l-8.863,6.335c-0.687,0.491-1.603-0.175-1.348-0.98l3.286-10.387   l-8.764-6.472c-0.679-0.501-0.329-1.579,0.515-1.585l10.895-0.084l3.447-10.335C364.772,240.795,365.905,240.795,366.172,241.595z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCk);
export default __webpack_public_path__ + "static/media/ck.85c69acdaa01e921f2412448c81be8c8.svg";
export { ForwardRef as ReactComponent };